import { Clock, Flame } from 'lucide-react'
import { boostCountdown, boostKindLabel, boostLiftPercent } from './prepackBoostModel'
import styles from './PrepacksBoostsPage.module.css'

export function PrepackBoostCard({ boost, now = Date.now() }) {
  const lift = boostLiftPercent(boost.baseOdds, boost.boostedOdds)
  const countdown = boostCountdown(boost.expiresAt, now)
  const expired = countdown === 'Expired'
  return (
    <article className={styles.card} data-kind={boost.kind} data-expired={expired || undefined} aria-label={boost.selection}>
      <div className={styles.cardTop}>
        <span className={styles.kind}><Flame className="h-3 w-3" aria-hidden="true" />{boostKindLabel(boost.kind)}</span>
        {countdown ? <span className={styles.countdown}><Clock className="h-3 w-3" aria-hidden="true" />{countdown}</span> : null}
      </div>
      <p className={styles.selection}>{boost.selection}</p>
      {boost.detail ? <p className={styles.detail}>{boost.detail}</p> : null}
      {boost.league || boost.event ? <p className={styles.matchup}>{[boost.league, boost.event].filter(Boolean).join(' · ')}</p> : null}
      {boost.surfaces.length > 0 ? (
        <div className={styles.liveOn}>
          <p className={styles.eyebrow}>Live on</p>
          <div className={styles.chips}>
            {boost.surfaces.map((s) => (
              <span key={s.surface} className={styles.chip} title={`${s.surface} · ${s.detail}`}>{s.surface}: {s.detail}</span>
            ))}
          </div>
        </div>
      ) : null}
      <div className={styles.prices}>
        <div>
          <p className={styles.eyebrow}>Was</p>
          <p className={styles.was}>{boost.baseOdds || '—'}</p>
        </div>
        <div>
          <p className={styles.eyebrow}>Boosted</p>
          <p className={styles.boosted}>{boost.boostedOdds || '—'}</p>
        </div>
        {lift != null ? <span className={styles.lift}>{lift >= 0 ? '+' : ''}{lift}%</span> : null}
      </div>
    </article>
  )
}
